<script>
import { mapGetters } from 'vuex';
import NotificationSummaryPopover from '../NotificationSummaryPopover.vue';

export default {
  components: {
    NotificationSummaryPopover,
  },
  props: {
    isSidebarCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      notificationMetadata: 'notifications/getMeta',
    }),
    unreadCount() {
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },
  },
  methods: {
    openNotificationPanel() {
      if (this.$route.name !== 'notifications_index') {
        this.$emit('openNotificationPanel');
      }
    },
  },
};
</script>

<template>
  <div class="relative">
    <NotificationSummaryPopover :is-sidebar-collapsed="isSidebarCollapsed" />
    <button
      class="relative flex items-center justify-center w-10 h-10 p-0 rounded-lg text-woot-600 dark:text-woot-100 hover:bg-woot-25 dark:hover:bg-woot-700 dark:hover:text-woot-100 hover:text-woot-600"
      :class="{
        'bg-woot-50 dark:bg-woot-800 text-woot-500 hover:bg-woot-50':
          isNotificationPanelActive,
      }"
      @click="openNotificationPanel"
    >
      <fluent-icon
        icon="alert"
        :class="{
          'text-woot-500': isNotificationPanelActive,
        }"
      />
      <span
        v-if="unreadCount"
        class="text-black-900 bg-yellow-300 absolute -top-0.5 -right-1 text-xxs min-w-[1rem] rounded-full"
      >
        {{ unreadCount }}
      </span>
    </button>
  </div>
</template>
